/* Dansk katalog for locale-settings-integrations-no.js (del 2 av 2).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('da', {
  'set.integr.wooImported': '{orders} salgs- og returhændelser importeret',
  'set.integr.wooLastSync': 'Sidst synkroniseret {date}',
  'set.integr.wooDisconnectTitle': 'Afbryd WooCommerce',
  'set.integr.wooDisconnectHelp': 'Plumme holder op med at hente nye ordrer og returneringer. Allerede importerede hændelser og bogførte dagsopgørelser bevares med revisionsspor.',
  'set.integr.wooDisconnectedToast': 'WooCommerce er afbrudt.',
  'set.integr.wooDisconnectError': 'WooCommerce kunne ikke afbrydes.',
  'set.integr.wooUnavailable': 'WooCommerce-integrationen er ikke tilgængelig i denne version.',
});
